import React, { FC } from 'react'

import { ButtonProps } from '../../components/Button'
import { HorizontalButton } from './HorizontalButtonGroup.styles'

export const HorizontalButtonGroupButton: FC<ButtonProps> = ({ children, ...others }) => (
  <HorizontalButton {...others}>{children}</HorizontalButton>
)
